import queryString from 'query-string';
import { Params } from 'react-router';

export function useQuery<ParamsOrKey extends string | Record<string, string | undefined> = string>(): Readonly<[
    ParamsOrKey
] extends [string] ? Params<ParamsOrKey> : Partial<ParamsOrKey>> {    
    const query = queryString.parse(window.location.search);     
    return query as any
}